/**
 * Created by Tiger on 21/03/2022.
 */

export const zh = {
    auth_tip: '授权 Google 访问青萍+ 设备',
    auth_tip2: '授权后，Google 会获得您的青萍+ 账号下的设备的控制权限。',
    google_privacy:'查看 Google 的',
    google_privacy2: '隐私政策',
    an_end: '。',
    confirm_auth: '同意并授权',
    read_privacy: '已阅读并同意',

    login_tip: '您正在授权 Google 控制您的设备，请先登录。',
    login_tip2: '如果您的账号未添加手机号或邮箱，请在青萍+ app 中发起授权。',
    input_password_tip: '输入账号 %@ 的密码。',
    code_sent_tip:'验证码已发送至 %@，有效期 10 分钟。',
    code_send_tip2:'如未收到，请检查垃圾邮件。',
    set_code_fail: '验证码获取失败',
    send_code_timeout:'%@ 秒后可重新获取',
    re_send_code:'重新获取验证码',
    login_fail: '登录失败',
    title_input_pwd: '输入密码' ,
    select_home: '选择国家/地区',
    country_code_placeholder: '搜索国家/地区名称'
};
